import classnames from 'classnames'
import { CSSProperties, useMemo } from 'react'

// Utils
import numberToRem from '@src/quince-site-common/src/utils/numberToRem'

import { RichText, RichTextProps } from '../../molecules/RichText'
import { Image, ImageProps } from '../image'

import styles from './iconWithText.module.scss'

export interface IconWithTextProps {
  iconProps?: ImageProps
  heading?: RichTextProps | null
  description?: RichTextProps
  className?: string
  hasBorder?: boolean
  maxImageWrapperHeight?: number
  imageWrapperClassName?: string
  enforceFixedSize?: boolean
}

export const IconWithText = ({ className = '', ...props }: IconWithTextProps) => {
  const wrapClassnames = classnames(styles.iconWithTextWrap, className)
  const maxImageWrapperHeight = useMemo(
    () =>
      ({
        '--maxImageWrapperHeight': props.maxImageWrapperHeight
          ? numberToRem(props.maxImageWrapperHeight, undefined)
          : undefined,
        height: props.iconProps?.height ? `${props.iconProps.height}px` : undefined,
        width: props.iconProps?.width ? `${props.iconProps.width}px` : undefined,
        aspectRatio:
          props.iconProps?.width && props.iconProps.height
            ? `${props.iconProps.width} / ${props.iconProps.height}`
            : undefined,
      }) as CSSProperties,
    [props.maxImageWrapperHeight, props.iconProps?.height, props.iconProps?.width],
  )
  return (
    <div className={wrapClassnames}>
      {props.iconProps && (
        <div style={maxImageWrapperHeight} className={classnames(styles.imageWrapper, props.imageWrapperClassName)}>
          <Image
            {...props.iconProps}
            alt={props.iconProps?.alt ?? ''}
            className={classnames(styles.icon, props.iconProps.className)}
            useNative
            enforceFixedSize={props.enforceFixedSize}
          />
        </div>
      )}
      <div className={styles.contentWrapper}>
        {props.heading && <RichText {...props.heading} />}
        {props.description && <RichText {...props.description} />}
      </div>
    </div>
  )
}

export default IconWithText
